export const fr = {
  // Login Page
  welcomeMessage: 'Bienvenue à',
  welcomeEmoji: '👋🏻',
  loginSubtitle: "Veuillez vous connecter à votre compte et commencer l'aventure",
  emailOrUsername: "Email ou nom d'utilisateur",
  emailPlaceholder: "Entrez votre email ou nom d'utilisateur",
  password: 'Mot de passe',
  passwordPlaceholder: '············',
  rememberMe: 'Se souvenir de moi',
  forgotPassword: 'Mot de passe oublié ?',
  login: 'Connexion',
  loggingIn: 'Connexion en cours...',
  newUser: 'Nouveau sur notre plateforme ?',
  createAccount: 'Créer un compte',
  or: 'ou',
  characterImage: 'Image du personnage',
  mask: 'Masque',

  // Navigation
  home: 'Accueil',
  about: 'À propos',
  inbox: 'Boîte de réception',
  assistants: 'Assistants',
  knowledgeBases: 'Bases de connaissances',
  personalAssistant: 'Assistant personnel',

  // User Dropdown
  userAlt: 'John Doe',
  userName: 'John Doe',
  userEmail: 'admin@vuexy.com',
  myProfile: 'Mon profil',
  settings: 'Paramètres',
  pricing: 'Tarification',
  faq: 'FAQ',
  logout: 'Déconnexion',

  // Mode Dropdown
  lightMode: 'Clair',
  darkMode: 'Sombre',
  systemMode: 'Système',
  modeTooltip: 'Mode',

  // Footer
  copyrightText: 'Fait avec',
  copyrightBy: 'par',
  companyName: 'NaqshAVA',
  licenseLink: 'Licence',
  moreThemesLink: 'Plus de thèmes',
  documentationLink: 'Documentation',
  supportLink: 'Support',

  // 404 Page
  pageNotFoundTitle: 'Page non trouvée ⚠️',
  pageNotFoundMessage: "Nous n'avons pas pu trouver la page que vous recherchez.",
  backToHome: "Retour à l'accueil",
  notFoundImageAlt: "Image d'erreur 404",

  // Dashboard Pages
  homePage: "Page d'accueil !",
  aboutPage: 'Page À propos !',

  // Register Page
  registerTitle: "L'aventure commence ici 🚀",
  registerSubtitle: 'Rendez la gestion de votre application facile et amusante !',
  username: "Nom d'utilisateur",
  usernamePlaceholder: "Entrez votre nom d'utilisateur",
  registerEmail: 'Email',
  registerEmailPlaceholder: 'Entrez votre email',
  agreeToTerms: "J'accepte la",
  privacyPolicyTerms: 'politique de confidentialité et les conditions',
  signUp: "S'inscrire",
  alreadyHaveAccount: 'Vous avez déjà un compte ?',
  signInInstead: 'Se connecter à la place',

  // Validation Messages
  usernameMinLength: "Le nom d'utilisateur doit contenir au moins 3 caractères",
  usernameMaxLength: "Le nom d'utilisateur doit contenir moins de 20 caractères",
  emailRequired: "L'email est requis",
  emailInvalid: 'Veuillez entrer un email valide',
  passwordMaxLength: 'Le mot de passe doit contenir moins de 50 caractères',
  agreeToTermsRequired: 'Vous devez accepter les termes et conditions',
  passwordMinLength: 'Le mot de passe doit comporter au moins 8 caractères.',
  passwordMustContainUppercase: 'Le mot de passe doit contenir des lettres majuscules anglaises.',
  passwordMustContainLowercase: 'Le mot de passe doit contenir des lettres minuscules anglaises.',
  passwordMustContainNumber: 'Le mot de passe doit contenir au moins un chiffre.',
  passwordMustContainSpecialChar: 'Le mot de passe doit contenir au moins un caractère spécial comme @$&.',
  questionRequired: 'La question est requise',
  answerRequired: 'La réponse est requise',
  messageCannotBeEmpty: 'Le message ne peut pas être vide',
  titleRequired: 'Le titre est requis',
  knowledgeBaseRequired: 'Veuillez sélectionner une base de connaissances',
  descriptionRequired: 'La description est requise',
  linkRequired: 'Le lien est requis',
  atLeastOneQuestionRequired: 'Ajoutez au moins une question',
  fileRequired: 'Un fichier est requis',

  // Register Page Metadata
  registerPageTitle: "S'inscrire",
  registerPageDescription: "Créez votre compte et commencez l'aventure",

  // Personal Assistant Page Metadata
  personalAssistantPageTitle: 'Assistant Personnel',
  personalAssistantPageDescription:
    'Votre assistant personnel intelligent pour vous aider avec les tâches quotidiennes et fournir des recommandations intelligentes',

  // Metadata
  metadataTitle: 'AINO - Modèle de Tableau de Bord Admin Next.js avec MUI',
  metadataDescription:
    'AINO - Modèle de Tableau de Bord Admin Next.js avec MUI - Le modèle le plus convivial pour les développeurs et hautement personnalisable construit sur MUI v5.',

  // Personal Assistant Feature
  startNewChat: 'Nouveau Chat',
  searchContacts: 'Rechercher des Contacts',
  selectContactToStart: 'Sélectionnez un contact pour commencer une conversation.',
  status: 'Statut',
  online: 'En ligne',
  away: 'Absent',
  doNotDisturb: 'Ne pas déranger',
  offline: 'Hors ligne',
  twoStepVerification: 'Vérification en Deux Étapes',
  notification: 'Notification',
  inviteFriends: 'Inviter des Amis',
  deleteAccount: 'Supprimer le Compte',
  typeAMessage: 'Tapez un message',
  chooseCollection: 'Sélectionnez votre base de connaissances',
  send: 'Envoyer',
  selectContact: 'Sélectionner un contact',
  content: 'Contenu',
  action: 'Action',
  deleteConfirm: 'Êtes-vous sûr de vouloir supprimer cet élément ?',
  yesDelete: 'Oui, supprimer',
  cancel: 'Annuler',
  apiKey: "Clé d'API",
  baseUrl: 'URL de Base',
  showSource: 'Afficher les Sources',
  apiKeyRequired: 'Clé API requise',
  baseUrlRequired: 'URL de base requise',
  invalidUrl: 'Doit être une URL valide',
  atLeastOneFieldRequired: 'Au moins un champ est requis',
  apiError: 'Échec de la mise à jour des paramètres',
  error: 'Erreur',
  balance: 'Solde',
  yourBalance: 'Votre solde :',
  passwordsMustNotMatch: 'Le nouveau mot de passe ne doit pas être identique à l’ancien',
  passwordsMustMatch: 'Le mot de passe et sa confirmation doivent correspondre',
  changePassword: 'Changer le mot de passe',
  currentPassword: 'Mot de passe actuel',
  repeatPassword: 'Répéter le mot de passe',
  name: 'Nom',
  PublishAssistant: 'Publier l’assistant',
  Step1: 'Pour intégrer cet assistant sur votre site web, copiez et collez le code ci-dessous dans la section',
  BodyTag: '<body>',
  Step1End: 'de votre fichier HTML.',
  Step2:
    'Une fois ajouté, l’assistant se chargera automatiquement sur votre page et sera prêt à interagir avec les utilisateurs.',
  Step3: 'Pour de meilleures performances, vous pouvez le placer en bas de votre HTML (avant la fermeture de',
  BodyTagEnd: '</body>',
  Step3End: ').',
  agentWelcomeMessage: 'Message de bienvenue',
  collectionTitle: 'Titre de la collection',
  color: 'Couleur',
  logo: 'Logo',
  avatar: 'Avatar',
  save: 'Enregistrer',
  welcomeMessageMin: 'Le message de bienvenue doit contenir au moins 5 caractères',
  collectionTitleMin: 'Le titre de la collection doit contenir au moins 2 caractères',
  colorInvalid: 'Format de couleur invalide',
  reset: 'Réinitialiser',
  savedSuccessfully: 'Enregistré avec succès',
  saveFailed: "Échec de l'enregistrement",
  customize: 'Personnaliser',
  publish: 'Publier',
  addAgent: 'Ajouter un assistant',
  collection: 'Collection',
  promptTemplate: 'Modèle de prompt',
  view: 'Voir',
  na: 'N/A',
  agentName: "Nom de l'assistant",
  isPreviouslyUsedPassword:
    'Veuillez choisir un autre mot de passe. Ce mot de passe a déjà été utilisé par vous et est dupliqué.',
  somethingWentWrong: 'Un problème est survenu, veuillez réessayer plus tard.',
  invalidEmailOrPassword: 'E-mail ou mot de passe invalide.',
  KnowledgeBaseSource: 'Source de base de connaissances',

  //menu
  chatBot: 'Chatbot',
  Agent: 'Agent',
  UnAnsweredQuestion: 'Questions sans réponse',
  PrivateRag: 'Assistant privé',
  'Personal Assistant': 'Assistant personnel',
  Setting: 'Paramètres',
  ContentCreator: 'Créateur de contenu',
  Inbox: 'Boîte de réception',
  Token: 'Jeton',
  KnowledgeBase: 'Base de connaissances',
  profile: 'Profil',
  firstName: 'Prénom',
  lastName: 'Nom de famille',
  phoneNumber: 'Numéro de téléphone',
  phoneNumberInvalid: 'Numéro de téléphone invalide',
  countryCodeLabel: 'Indicatif pays',
  countryCodeHelper: 'Choisissez l’indicatif téléphonique',
  countryIran: 'Iran',
  countryCanada: 'Canada',
  countryUnitedStates: 'États-Unis',
  countryUnitedKingdom: 'Royaume-Uni',
  countryGermany: 'Allemagne',
  countryFrance: 'France',
  countryJapan: 'Japon',
  allowedFileTypes: 'Formats autorisés : JPG, GIF ou PNG',
  fileSizeLimit: 'La taille du fichier doit être inférieure à 800 Ko.',
  uploadNewPhoto: 'Télécharger une nouvelle photo',
  unansweredQuestions: 'Cevaplanmamış Sorular',
  noUnansweredQuestions: 'Cevaplanacak soru bulunamadı',
  writeAnswerOfFollowingQuestion: 'Aşağıdaki sorunun cevabını yazın:',
  pleaseEnterDesiredAnswer: 'Lütfen istenen cevabı girin',
  Answered: 'Répondu',

  //shared
  headerTitle: "Titre de l'en-tête",
  headerBackground: "Arrière-plan de l'en-tête",
  messageTitle: 'Titre du message',
  messageTextColor: 'Couleur du texte du message',
  messageBackground: 'Arrière-plan du message',
  footerBackground: 'Arrière-plan du pied de page',
  chatBackground: 'Arrière-plan du chat',
  floatingButtonPosition: 'Position du bouton flottant',
  floatingButtonIcon: 'Icône du bouton flottant',
  shouldUseAI: "Utiliser l'IA",
  shouldUseAIHint: "Si vous désactivez cette option, vous devrez répondre vous-même aux messages d'assistance.",
  buttonColor: 'Couleur du bouton',
  bottomLeft: 'Bas à gauche',
  bottomRight: 'Bas à droite',
  imageFile: 'Fichier image',
  acceptableFormatsForImage: 'Formats acceptés : jpg, jpeg, png',

  //transactions
  goToPayment: 'Aller au paiement',
  price: 'Montant',
  continuePayment: 'Continuer au paiement',
  amountMustBeGreaterThan100000: 'Le montant doit être supérieur à 1,000,000',
  selectPackageFirst: 'Veuillez sélectionner un package d’abord',
  recentTransactions: 'Transactions récentes',
  yourLatestFinancialActivities: 'Vos dernières activités financières',
  newest: 'Le plus récent',
  oldest: 'Le plus ancien',
  latest: 'Dernier',
  noRecentTransactionsFound: 'Aucune transaction récente trouvée.',
  transactionDetails: 'Détails de la transaction',
  share: 'Partager',
  export: 'Exporter',
  paymentSuccessfullyCompleted: 'Paiement effectué avec succès',
  fundsTransferredSecurely: 'Les fonds ont été transférés en toute sécurité',
  paymentPending: 'Paiement en attente',
  paymentIsPending: 'Votre paiement est en attente !',
  paymentUnsuccessful: 'Paiement échoué',
  fundsNotTransferred: "Les fonds n'ont pas été transférés",
  userInformation: "Informations sur l'utilisateur",
  cardDeposit: 'Dépôt par carte',
  sourceCardNumber: 'Numéro de carte source',
  destinationCardNumber: 'Numéro de carte destination',
  paymentProvider: 'Fournisseur de paiement',
  transactionId: 'ID de transaction',
  referenceNumber: 'Numéro de référence',
  explanation: 'Explication',
  chatbotChargeMessage: 'Cette charge a été effectuée pour poser la question suivante au chatbot :',
  currentBalanceAfterTransaction: 'Solde actuel après la transaction',
  date: 'Date',
  wallet: 'Portefeuille',
  chargeYourAccount: 'Recharger votre compte',
  totalBalance: 'Solde total',
  BadUserNameError: "Le nom d'utilisateur saisi n'est pas valide.",
  DuplicateUserName: "Le nom d'utilisateur est déjà utilisé.",
  DuplicateEmail: "Le nom d'utilisateur est déjà utilisé.",
  aiModelRequired: "Veuillez sélectionner un modèle d'IA.",
  aiModel: "Modèle d'IA",
  backToWallet: 'Retour au portefeuille',

  filters: 'Filtres',
  loading: 'Chargement...',
  agent: 'Agent',
  agentPlaceholder: 'Choisir un agent',
  statusPlaceholder: 'Sélectionner un statut',
  openChat: 'Discussions ouvertes',
  closeChat: 'Discussions fermées',
  humanSupport: 'Support humain',
  apply: 'Appliquer',
  connectHumanSupport: 'Contacter le support humain',
  all: 'Tous',
  seeConversation: 'Voir la conversation',
  noData: 'Aucune donnée trouvée',
  agentPageTitle: 'Détails de l’assistant',
  agentPageDesc: 'Voir les détails complets de votre assistant personnel',
  inboxPageDesc: 'Voir vos messages et notifications reçus',
  unansweredQuestionsDesc: 'Voir toutes les questions non répondues des utilisateurs et les gérer efficacement',
  PaymentResultTitle: 'Facture',
  PaymentResultDescription:
    'Le résultat de votre paiement a été traité. Vous pouvez consulter tous les détails de la transaction sur cette page.',
  notEnoughBalance: 'Solde insuffisant',

  // Error Messages
  insufficientBalance: 'Solde insuffisant',
  pleaseRechargeYourAccount:
    'Le solde de votre compte est trop faible. Veuillez recharger pour continuer à utiliser le service.',
  recharge: 'Recharger maintenant',
  networkError: 'Erreur réseau',
  checkYourConnection: 'Veuillez vérifier votre connexion Internet et réessayer.',
  errorOccurred: "Une erreur s'est produite",
  pleaseTryAgain: "Quelque chose s'est mal passé. Veuillez réessayer plus tard.",

  //packages
  starterPlan: 'Planne de démarrage',
  growthPlan: 'Planne de croissance',
  professionalPlan: 'Planne professionnelle',
  starterPlanDesc: '1 000 000 tomans',
  growthPlanDesc: 'Rechargez votre compte avec 4 500 000 tomans et recevez 5 000 000 tomans de crédit !',
  professionalPlanDesc: 'Rechargez votre compte avec 8 000 000 tomans et recevez 10 000 000 tomans de crédit !',
  starterPlanFeature1: 'Accès à toutes les fonctionnalités d’Aino',
  starterPlanFeature2: 'Crédit utilisable dans Private RAG, Chatbot et Content Creator',
  starterPlanFeature3: 'Adapté aux tests, aux petits projets ou aux équipes débutantes',
  growthPlanFeature1: 'Accès à toutes les fonctionnalités d’Aino',
  growthPlanFeature2: 'Adapté à une utilisation en équipe',
  growthPlanFeature3: '10 % d’économie par rapport au plan de démarrage',
  professionalPlanFeature1: 'Accès à toutes les fonctionnalités d’Aino',
  professionalPlanFeature2: 'Rentabilité économique et stabilité d’utilisation',
  professionalPlanFeature3: 'Adapté aux projets de grande envergure et de longue durée',

  // Error Handler
  accessDenied: 'Accès refusé',
  noAccessToResource: "Vous n'avez pas la permission d'accéder à cette ressource.",
  ok: 'OK',
  close: 'Fermer'
}
